var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgC(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.4 12.24C9.296 12.24 11.024 10.4 11.536 8.48L9.776 7.904C9.392 9.184 8.304 10.4 6.4 10.4C4.464 10.4 2.64 8.992 2.64 6.336C2.64 3.584 4.512 2.224 6.384 2.224C8.288 2.224 9.344 3.328 9.68 4.704L11.488 4.096C10.976 2.112 9.264 0.415999 6.384 0.415999C3.44 0.415999 0.672 2.64 0.672 6.336C0.672 10.032 3.344 12.24 6.4 12.24Z",
    fill: "#FF66A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC);
export default __webpack_public_path__ + "static/media/C.ea97aa90.svg";
export { ForwardRef as ReactComponent };